import React, { useEffect, useState } from "react";
import useAPI from "../../hooks/useAPI";
import Price from "../Price";

const BaseProduct = ({ baseProduct }) => {
  // const { API } = useAPI();
  const [showMoreDesc, setShowMoreDesc] = useState(false);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    if (!baseProduct) {
      return alert("No base product - shouldnt happen");
    }
    console.log("baseProduct", baseProduct);
  }, []);

  return (
    <div className="sb-base-product">
      <div>
        <div>
          {baseProduct.images.map((image) => {
            return <img key={image.url_standard} src={image.url_standard} />;
          })}
        </div>
        {baseProduct.videos && (
          <div style={{ backgroundColor: "#eaeaea" }}>
            <div>
              {baseProduct.videos.map((video, idx) => {
                if (idx === 0) {
                  let thumbnailUrl =
                    "https://img.youtube.com/vi/" + video.video_id + "/0.jpg";
                  let videoUrl = `https://www.youtube.com/watch?v=${video.video_id}`;
                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          flex: 5,
                          backgroundImage: `url(${thumbnailUrl})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            paddingBottom: "56.25%",
                          }}
                        ></div>
                        {/* <img src={thumbnailUrl} /> */}
                      </div>
                      <div style={{ flex: 7, padding: "15px" }}>
                        <h5>{video.title}</h5>
                        {/* <a href={videoUrl} target="_blank">
                          Play Video
                        </a> */}
                        <a
                          onClick={() => {
                            let video = {
                              videoUrl,
                              embedSrc: videoUrl.replace(
                                "https://www.youtube.com/watch?v=",
                                "https://www.youtube.com/embed/"
                              ), //-DQi11RORYw"//`https://www.youtube.com/embed/M7lc1UVf-VE?autoplay=1`
                            };
                            setVideo(video);
                          }}
                        >
                          Play Video
                        </a>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
                // return <img src={image.url_standard} />;
              })}
            </div>
          </div>
        )}
      </div>

      <div className="sb-base-product-desc">
        <small>Base product: {baseProduct && baseProduct.id}</small>
        <h1>{baseProduct.name}</h1>
        <h6>
          From <Price value={baseProduct.price} />
        </h6>
        <div
          dangerouslySetInnerHTML={{ __html: baseProduct.description }}
          style={{ maxHeight: "130px", overflow: "hidden" }}
        ></div>
        <br />
        <a
          onClick={() => {
            setShowMoreDesc(true);
          }}
        >
          More
        </a>
      </div>

      {showMoreDesc && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            backgroundColor: "rgba(255,255,255,0.5)",
            height: "100%",
            zIndex: 1000,
            padding: "30px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              width: "800px",
              maxWidth: "70vw",
              padding: "30px",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "15px",
              maxHeight: "100%",
              overflow: "auto",
              boxShadow: "2px 2px 66px rgb(0, 0, 0, 0.1)",
            }}
          >
            <div style={{ textAlign: "right" }}>
              <a
                onClick={() => {
                  setShowMoreDesc(false);
                }}
              >
                Close
              </a>
            </div>
            <h1>{baseProduct.name}</h1>
            <div
              dangerouslySetInnerHTML={{ __html: baseProduct.description }}
              style={{}}
            ></div>
          </div>
        </div>
      )}
      {video && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            backgroundColor: "rgba(255,255,255,0.5)",
            height: "100%",
            zIndex: 1000,
            padding: "30px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              width: "800px",
              maxWidth: "70vw",
              padding: "30px",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "15px",
              maxHeight: "100%",
              overflow: "hidden",
              boxShadow: "2px 2px 66px rgb(0, 0, 0, 0.1)",
            }}
          >
            <div style={{ textAlign: "right" }}>
              <a
                onClick={() => {
                  setVideo(null);
                }}
              >
                Close
              </a>
            </div>
            <h1>{baseProduct.name}</h1>
            <div style={{ maxWidth: "100%" }}>
              {/* <h1>VIDEO GOES HERE</h1> */}
              <iframe
                id="ytplayer"
                type="text/html"
                width="640"
                height="360"
                src={video.embedSrc}
                frameborder="0"
                style={{ maxWidth: "100%" }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
      {/* {baseProduct ? (
        <div>
          <h2>{baseProduct.name}</h2>
          {baseProduct.images.map((image) => {
            return <img src={image.url_standard} />;
          })}
          <p>{baseProduct.description}</p>
          <h3>From £{baseProduct.price}</h3>
        </div>
      ) : (
        "No base product from BC"
      )} */}
      {/* <p>Base product info to be shown here</p> */}
    </div>
  );
};

export default BaseProduct;
